import React from "react";
import { Outlet } from "react-router-dom";
import { Auth0ProviderWithNavigate } from "../auth/auth0-provider";
import { AuthRoutesProvider } from "./auth-routes-provider";
import { SupervisorModeProvider } from "./supervisor-mode-provider";

// Root layout that lives inside the router so the Auth0 provider can use
// navigation for its redirect callback. Wraps the whole app in the auth and
// supervisor-mode providers.
export const RootLayout: React.FC = () => {
  return (
    <Auth0ProviderWithNavigate>
      <AuthRoutesProvider>
        <SupervisorModeProvider>
          <Outlet />
        </SupervisorModeProvider>
      </AuthRoutesProvider>
    </Auth0ProviderWithNavigate>
  );
};
